module.exports = __webpack_public_path__ + "1de18558e556536a227801779aa94771.svg";